var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pi_container" },
    [
      _c("div", {
        staticClass: "el-icon-circle-close pi_close_btn",
        on: { click: _vm.closePI },
      }),
      _c(
        "el-row",
        { staticClass: "pi_box" },
        [
          _c("el-col", { staticClass: "pi_btn_type", attrs: { span: 5 } }, [
            _c(
              "div",
              {
                class: _vm.clickType === 1 ? "clickBtn" : "noClickBtn",
                on: {
                  click: function ($event) {
                    return _vm.clickTypeChange(1)
                  },
                },
              },
              [
                _c("svg-icon", { attrs: { "icon-class": "orderPackage" } }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("collectionCenter.smallParcelPriceInquiry")) +
                    " "
                ),
              ],
              1
            ),
            _c("br"),
            _c(
              "div",
              {
                class: _vm.clickType === 2 ? "clickBtn" : "noClickBtn",
                on: {
                  click: function ($event) {
                    return _vm.clickTypeChange(2)
                  },
                },
              },
              [
                _c("svg-icon", { attrs: { "icon-class": "truck" } }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("collectionCenter.largeParcelPriceInquiry")) +
                    " "
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            {
              staticStyle: {
                padding: "10px 100px",
                "box-sizing": "border-box",
              },
              attrs: { span: 19 },
            },
            [
              _c(
                "el-form",
                {
                  ref: "ruleRef",
                  staticClass: "pi_form",
                  attrs: { model: _vm.ruleForm, rules: _vm.rules },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "justify-content": "space-between",
                        "align-items": "center",
                        "flex-wrap": "wrap",
                      },
                      attrs: { type: "flex" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("placeOrder.client"),
                                prop: "customerId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    "remote-method": _vm.getCustomerPage,
                                  },
                                  on: { clear: _vm.getCustomerPage },
                                  model: {
                                    value: _vm.ruleForm.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "customerId", $$v)
                                    },
                                    expression: "ruleForm.customerId",
                                  },
                                },
                                _vm._l(_vm.customerList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.username,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("uploadFile.senderPostalCode"),
                                prop: "senderZipcode",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.input8ZipCode"
                                  ),
                                  maxlength: 9,
                                  clearable: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.filterNumber("senderZipcode")
                                  },
                                  blur: function ($event) {
                                    return _vm.zipCodeVal("senderZipcode")
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.senderZipcode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "senderZipcode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.senderZipcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("uploadFile.recipientPostalCode"),
                                prop: "receiveZipcode",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.input8ZipCode"
                                  ),
                                  maxlength: 9,
                                  clearable: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.filterNumber("receiveZipcode")
                                  },
                                  blur: function ($event) {
                                    return _vm.zipCodeVal("receiveZipcode")
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.receiveZipcode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "receiveZipcode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.receiveZipcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("placeOrder.parcelWeight"),
                                prop: "weight",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "0.00", clearable: "" },
                                on: {
                                  input: function (val) {
                                    return _vm.filterInput("weight", val)
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.weight,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "weight", $$v)
                                  },
                                  expression: "ruleForm.weight",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("GlobalSetObj.PackageTotalWeight") +
                                  (_vm.clickType === 1 ? "(cm³)" : "(m³)"),
                                prop: "totalParcelDeclaredVolume",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "100%",
                                  "margin-bottom": "5px",
                                },
                                attrs: {
                                  placeholder: "0.00",
                                  max: 999,
                                  clearable: "",
                                },
                                on: { input: _vm.filterInputVolume },
                                model: {
                                  value: _vm.ruleForm.totalParcelDeclaredVolume,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "totalParcelDeclaredVolume",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "ruleForm.totalParcelDeclaredVolume",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "pi_ckg_box" }, [
                          _c("span", { staticClass: "pi_ckg_title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "collectionCenter.lengthWidthHeightOptional"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "pi_ckg_input" },
                            [
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "30%" },
                                  attrs: { clearable: "" },
                                  on: {
                                    input: function (val) {
                                      return _vm.filterInputCKG("length", val)
                                    },
                                  },
                                  model: {
                                    value: _vm.ruleForm.length,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "length", $$v)
                                    },
                                    expression: "ruleForm.length",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "prefix" },
                                      slot: "prefix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("collectionCenter.long"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.clickType === 1 ? "cm" : "m")
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "30%" },
                                  attrs: { clearable: "" },
                                  on: {
                                    input: function (val) {
                                      return _vm.filterInputCKG("width", val)
                                    },
                                  },
                                  model: {
                                    value: _vm.ruleForm.width,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "width", $$v)
                                    },
                                    expression: "ruleForm.width",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "prefix" },
                                      slot: "prefix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("collectionCenter.width"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.clickType === 1 ? "cm" : "m")
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "30%" },
                                  attrs: { clearable: "" },
                                  on: {
                                    input: function (val) {
                                      return _vm.filterInputCKG("height", val)
                                    },
                                  },
                                  model: {
                                    value: _vm.ruleForm.height,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "height", $$v)
                                    },
                                    expression: "ruleForm.height",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "prefix" },
                                      slot: "prefix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.height")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.clickType === 1 ? "cm" : "m")
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "pi_ckg_title",
                            staticStyle: { color: "#878787 !important" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.clickType === 1
                                    ? _vm.$t("collectionCenter.volumeUnitNote")
                                    : _vm.$t(
                                        "collectionCenter.volumeUnitNoteM3"
                                      )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "15px" },
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("placeOrder.InvoiceAmount") + "(R$)",
                                prop: "invoiceMoney",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "0.00", clearable: "" },
                                on: {
                                  input: function (val) {
                                    return _vm.filterInput("invoiceMoney", val)
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.invoiceMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "invoiceMoney", $$v)
                                  },
                                  expression: "ruleForm.invoiceMoney",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "el-icon-search pi_search_btn",
                  on: { click: _vm.queryQuote },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("collectionCenter.queryQuote")) + " "
                  ),
                ]
              ),
              _vm.isloadingBtn
                ? _c("div", { staticClass: "pi_loading_btn" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("collectionCenter.waitingForQuote")) +
                        " "
                    ),
                  ])
                : _c(
                    "div",
                    { staticClass: "pi_sum_box" },
                    [
                      _c("svg-icon", { attrs: { "icon-class": "coins" } }),
                      _vm._v(
                        _vm._s(
                          _vm.$t("collectionCenter.estimatedShippingCost")
                        ) + " "
                      ),
                      _c("br"),
                      _c("span", { staticClass: "pi_sum" }, [
                        _vm._v("R$ " + _vm._s(_vm.sumPrice)),
                      ]),
                    ],
                    1
                  ),
              !_vm.isloadingBtn
                ? _c("div", { staticClass: "pi_sum_tips" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("collectionCenter.estimatedShippingDisclaimer")
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }